import { createRemittanceConfig } from "cy-remittance-config";

/**
 * Shoprite Send remittance configuration.
 */
export const remittanceConfig = createRemittanceConfig({
  companyName: "Shoprite Send",
  shortCompanyName: "ShopriteSend",
  contactDetails: {
    supportEmail: "help@shopritesend.co.za",
    supportPhone: {
      display: "+27 11 214 1743",
      value: "+27112141743",
    },
    infoEmail: "info@shopritefinancialservices.co.za",
    whatsappNumber: "081 813 3911",
  },
});
